import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 15 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 0.75, d: "M4.5.5v3m6-3v3m-9.75 3h13.5m-9.75 3h.008m2.992 0h.008m2.992 0h.008m-6.008 3h.008m2.992 0h.008m2.992 0h.008M2.25 2h10.5a1.5 1.5 0 0 1 1.5 1.5V14a1.5 1.5 0 0 1-1.5 1.5H2.25A1.5 1.5 0 0 1 .75 14V3.5A1.5 1.5 0 0 1 2.25 2" }));
const ForwardRef = forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
